import React from 'react';
import { Grid, Segment } from 'semantic-ui-react';
import '../auth.css';
import axios from 'axios';
import {reactLocalStorage} from 'reactjs-localstorage';
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import { Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react'
import Modal from 'react-modal';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import { Pagination } from 'semantic-ui-react';
import { API_BASE_URL } from "../utils/endpoints";

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};


class Request extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
         data:[],
         personssearch:[],
         modalIsOpen: false,
         from:'',
         sender_id:'',
         id_record:'',
         totalpage:'1',
         activePage: 1,
      
    }
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
}
openModal() {
  this.setState({modalIsOpen: true});
}
handlePaginationChange = (e, { activePage }) => this.setState({ activePage })
afterOpenModal() {
}

closeModal() {
  this.setState({modalIsOpen: false});
}
componentDidMount() {
  var lang=i18n.language;
  if(lang ==="ar")
  {
    document.querySelector('.ko7le_color').style = 'text-align:right;width: 20%;margin-right: 14%;white-space: pre;';       
    document.querySelector('.icon_logo').style = 'float: left;margin-top: 0%; margin-right: -5%;width: 7%;cursor: pointer; margin-left: -11%;';
    document.querySelector('.list_ar').style = 'display:block';
    document.querySelector('.list_en').style = 'display:none';
  }
  this.changeData()
      if(reactLocalStorage.get('role') ==='ROLE_OPERATOR')
      {
        
       document.querySelector('.icon_logo').style = 'display:none';
      
      }
      if(reactLocalStorage.get('role') ==='ROLE_SUBADMIN' ||reactLocalStorage.get('role') ==='ROLE_ADMIN' )
      {
        

       document.querySelector('.approve_cycle').style = 'display:none';
       
      }
}
changeData=()=>{
  var token=reactLocalStorage.get('accessToken');
    
    
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  var page_num=this.state.activePage -1;
  var search=''
  if(ip.includes(s2))
  {
   apiBaseUrl =API_BASE_URL + "/core/corpsms/getrequest?page="+page_num+"&filter="+search;
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/corpsms/getrequest?page="+page_num+"&filter="+search;
  }


  var headers = {'Content-Type': 'application/json', 'token' :token }
  axios.get(apiBaseUrl,{headers: headers})
      .then(res => {
       this.setState({data:res.data.result.requests})
       var total=Math.ceil(res.data.result.count/20);
   
       this.setState({totalpage :total});
      })
}

viewdata= event =>{
  this.setState({modalIsOpen: true});

}


approve =event=>{

}
reject =event=>{
  
}

    searchchange=(event)=>{
      var token=reactLocalStorage.get('accessToken');
    
      document.querySelector('.view_basic').style = 'display:none';
      document.querySelector('.view_search').style = 'display:block';
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var page_num=this.state.activePage -1;
      if(ip.includes(s2))
      {
       apiBaseUrl =API_BASE_URL + "/core/corpsms/getrequest?page="+page_num+"&filter="+event.target.value;
      }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/corpsms/getrequest?page="+page_num+"&filter="+event.target.value;
      }
    
    
      var headers = {'Content-Type': 'application/json', 'token' :token }
      axios.get(apiBaseUrl,{headers: headers})
          .then(res => {
          this.setState({personssearch:res.data.result.requests})
           
          })
    }
    test(value){
      var d = new Date(value),
      dformat = [d.getMonth()+1,
       d.getDate(),
       d.getFullYear()].join('/')+' '+
      [d.getHours(),
       d.getMinutes(),
       d.getSeconds()].join(':');
       return dformat;
    }  
    render(){
      const { activePage } = this.state;
        return(
          <div className="big_div">
          <Menutest/>
          <div className="actionMenu">
            <div className="main_div_request">
            <div className="main_request">
                  <Grid columns={2} divided>
                    <Grid.Row stretched>
        
            
            
                      <Grid.Column className="grid_logo">
                        <Segment>
                        <h3 className="text_style ko7le_color">{i18n.t('Request_sender_id.label')} </h3>
                        </Segment>
                      </Grid.Column>
            
                      <Grid.Column className="grid_language" style={{width:'44%'}}>
                        <Segment>
                          <Link to="/app/AddRequestSenderID">
                     <img  src={require('../pictures/plus_ko7le.png')} className="Logo_auth icon_logo" alt="logo" />
                     </Link>
                     <input
                      placeholder="Search for..."
                      onChange={this.searchchange.bind(this)}
                      className="search_web search_sub"
                      style={{padding: '3px',marginTop: '1%'}}
                       />
            
                        </Segment>
                      </Grid.Column>
            
            
            
                    </Grid.Row>
                  </Grid>
                  <input
                      placeholder="Search for..."
                      className="search_mobile"
                      onChange={this.searchchange.bind(this)}
                      style={{padding: '3px',marginTop: '1%'}}
             />
                  <hr/>

                  
      <div className="container_cards">

      <div className="content_report view_basic">
                    <Table bordered>
        <thead>
          <tr>
            <th style={{display:'none'}}></th>
            <th className="approve_cycle"></th>
            <th>{i18n.t('from.label')}</th>
            <th>{i18n.t('to.label')}</th>
            <th>{i18n.t('sender_id.label')}</th>
            <th>{i18n.t('Status.label')}</th>
            <th>{i18n.t('time.label')}</th>
           
          </tr>
         
        </thead>
		{ this.state.data.slice(0).reverse().map(person =>
        <tbody>
		<tr>
    <td className="approve_cycle" style={{display:'none'}}>
     <Button id={person.id} from={person.from} sender={person.value} onClick={this.viewdata} className="view_details" >{i18n.t('view_details.label')} </Button></td>
     <td className="bulk_data">{person.from}</td>
		 <td className="bulk_data">{person.to}</td>
		 <td className="bulk_data">{person.value}</td>
		 <td className="bulk_data">{person.status}</td>
		 <td className="bulk_data">{person.created_time  ?  this.test(person.created_time)  : ''}</td>
		</tr>
		</tbody>
		)}
		</Table>
                        </div>
    <div className="content_report view_search" style={{display:'none'}}>
                    <Table bordered>
        <thead>
          <tr>
          <th className="approve_cycle" style={{display:'none'}}></th>

            <th>{i18n.t('from.label')}</th>
            <th>{i18n.t('to.label')}</th>
            <th>{i18n.t('sender_id.label')}</th>
            <th>{i18n.t('Status.label')}</th>
            <th>{i18n.t('time.label')}</th>
           
          </tr>
         
        </thead>
		{ this.state.personssearch.slice(0).reverse().map(person =>
        <tbody>
		<tr>
    <td className="approve_cycle" style={{display:'none'}}><Button id={person.id} onClick={this.viewdata} className="view_details" >{i18n.t('view_details.label')} </Button></td>

		 <td className="bulk_data">{person.from}</td>
		 <td className="bulk_data">{person.to}</td>
		 <td className="bulk_data">{person.value}</td>
		 <td className="bulk_data">{person.status}</td>
		 <td className="bulk_data">{person.created_time  ?  this.test(person.created_time)  : ''}</td>
		</tr>
		</tbody>
		)}
		</Table>
                        </div>



</div>
<Pagination
            activePage={activePage}
            onPageChange={this.handlePaginationChange}
            onClick={this.changeData}
            totalPages={this.state.totalpage}
            className="page"
            style={{marginRight: '2.5%'}}
          /> 
                  </div>
  
                  </div> 
                  <Modal
      isOpen={this.state.modalIsOpen}
      onAfterOpen={this.afterOpenModal}
      onRequestClose={this.closeModal}
      style={customStyles}
      contentLabel="Example Modal"
      className="data_modal"
     
>
<i class="close icon" onClick={this.closeModal}></i>
  <h2 ref={subtitle => this.subtitle = subtitle} className="report_title">{i18n.t('Details.label')}</h2>
  
  <br/>
  <div className="" style={{marginTop: '-3%'}}>

          
  <div className="view_basics view_report">
  <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="" style={{border:'none'}}>
            <MDBCardBody>
              <form onSubmit={this.handleSubmit}>
              <p className="h6 black_color">{i18n.t('from.label')}</p>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="type"
                  
                />
                <br />
               
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                 
                  {i18n.t('sender_id.label')}
                </label>
                <input
                  type="test"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="sender_id"
                  onChange={this.handleChangeSenderID}
                />
                <br />

                  <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_ko7le" style={{paddingTop: '0.3%'}}>

                    <MDBBtn color="cyan"  onClick={this.approve}>
                    {i18n.t('approve.label')}

                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_ko7le" style={{paddingTop: '0.3%'}} onClick={this.reject}>
                    <MDBBtn color="cyan">
                    {i18n.t('reject.label')}
                    </MDBBtn>
                    </Button>

                  </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div>


  </div>



 
  </div>
 


</Modal> </div>  </div>
        );
    }
}

const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (Request);
